import { render, staticRenderFns } from "./VTaskForm.vue?vue&type=template&id=41541d6c&"
import script from "./VTaskForm.vue?vue&type=script&lang=js&"
export * from "./VTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./VTaskForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports